import { render, staticRenderFns } from "./OrderPacking.vue?vue&type=template&id=5b76f576&scoped=true&"
import script from "./OrderPacking.vue?vue&type=script&lang=js&"
export * from "./OrderPacking.vue?vue&type=script&lang=js&"
import style0 from "./OrderPacking.vue?vue&type=style&index=0&id=5b76f576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b76f576",
  null
  
)

export default component.exports